import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
const paysList = require('../../../../assets/jsons/countries.json');
import { models } from '../modele/modele-form';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/services/utils.service';
import { SubscriptionService } from 'src/app/services/subscription.service';

import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-mrh',
  templateUrl: './mrh.component.html',
  styleUrls: ['./mrh.component.scss']
})
export class MrhComponent implements OnInit {

  // Navigation et état
  currentStep = 0;
  totalSteps = 4; // accueil + 1 étape + 1 étape garanties + récapitulatif
  
  // Formulaire principal
  simulationMrhForm: FormGroup;
  
  // États de l'interface
  loader: boolean = false;
  sendingRequest: boolean = false;
  isFocus: boolean = false;
  hasPhoneError: boolean = false;
  
  // Données
  listPays = paysList;
  listQualiteProposant = [
    {name:'Locataire', value:'Locataire'}, 
    {name:'Propriétaire', value:'Propriétaire'}
  ];
  listGaranties = [
    {name:'Incendie', value:'Incendie'}, 
    {name:'Vol', value:'Vol'}, 
    {name:'Dégats des eaux', value:'Dégats des eaux'}, 
    {name:'Bris de glace', value:'Bris de glace'}, 
    {name:'RC chef de famille', value:'RC chef de famille'}
  ];
  
  // Configuration
  newDate = new Date();
  emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  // Références
  numeroSous: string;
  refPro: string;
  
  // Informations de la page
  slideData;
  lien = "";
  informations;
  title = "";

  // Document technique
  nomFile: string = "";
  noImage: string = "assets/images/upload.png";
  pieceJointe: FormGroup;
  downloadIcon = "assets/fileDownload/file.png";
  downloadFile: boolean = true;
  typeProduitList: any = {
    questionnaireUrl: '/assets/fileDownload/questionnaire_mrh.pdf'
  };

  currentFiliale = JSON.parse(localStorage.getItem('currentFiliale'));

    // ===== AJOUT POUR AUTOSAVE =====
  private autoSaveSubject$ = new Subject<any>();
  private autoSaveSubscription: Subscription;
  private lastSavedData: string = ''; // Pour comparer les données
  // ================================

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private utilsService: UtilsService,
    private rechercheService: SubscriptionService
  ) {
    // Initialisation des références
    let time = new Date().getTime();
    let pro = new Date().getTime() + 123890989;
    this.numeroSous = "SN" + time + "MRH";
    this.refPro = "SN" + pro + "PR";

    // @ts-ignore
    // let lienBrute: String = this.route.snapshot._routerState.url;
    // this.lien = lienBrute.substring(1, lienBrute.length);
    // this.informations = models[this.lien];
        
    // localStorage.setItem('sectionShown', this.lien);
    // this.slideData = [{
    //   title: "Inclusive Market",
    //   subTitle: "Toutes vos assurances en 1 seul endroit",
    //   description: "Votre devis gratuit personnalisé en quelques clics",
    //   img: "assets/images/slide-mrh.png",
    //   type: "ASSURANCE MULTIRISQUE HABITAT",
    //   imgIcon: "assets/images/home-green.svg"
    // }]; 

    let lienBrute: String = this.route.snapshot._routerState.url;
    this.lien = lienBrute.substring(1, lienBrute.length);
    this.informations = models[this.lien];
        
    localStorage.setItem('sectionShown', this.lien);
    this.slideData = [{
      title: "Inclusive Market",
      subTitle: "Toutes vos assurances en 1 seul endroit",
      description: "Votre devis gratuit personnalisé en quelques clics",
      img: "assets/images/slide-mrp.png",
      type: "ASSURANCE MULTIRISQUE HABITAT",
      imgIcon: "assets/images/foreman-green.svg"
    }]; 
  }

  ngOnInit() {
    this.initializeForm();
     this.setupAutoSave();
  }

  // Initialisation du formulaire
  initializeForm() {
    this.simulationMrhForm = this.fb.group({
      // Informations générales
      nom: ['', Validators.required],
      adresse: [''],
      email: new FormControl('', [Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])]),
      telephone: ['', Validators.required],
      profession: ['', Validators.required],
      qualiteProposant: ['', Validators.required],
      
      // Informations sur le logement
      adresseRisque: ['', Validators.required],
      nombrePieces: ['', Validators.required],
      valeurContenu: ['', Validators.required],
      valeurBatiment: ['', Validators.required],
      loyer: [''],
      
      // Garanties
      garanties: [[], Validators.required]
    });

    // FormGroup séparé pour le document technique
    this.pieceJointe = new FormGroup({
      file: new FormControl('')
    });
  }

  // Navigation entre les étapes
  nextStep() {
    if (this.currentStep === 0) {
      // Depuis la page d'accueil, on va aux informations générales
      this.currentStep = 1;
      setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 100);
      return;
    }
    
    if (this.isCurrentStepValid()) {
      if (this.currentStep < 4) {
        this.currentStep++;
        setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 100);
      }
    } else {
      this.markFormGroupTouched();
      this.toastr.warning("Veuillez remplir tous les champs obligatoires", "Attention");
    }
  }

  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      window.scrollTo(0, 0);
    }
  }

  // Validation des étapes
  isCurrentStepValid(): boolean {
    switch (this.currentStep) {
      case 0: // Page d'accueil
        return true;
        
      case 1: // Informations générales (tous les champs)
        return this.simulationMrhForm.get('nom')?.valid && 
               this.simulationMrhForm.get('telephone')?.valid &&
               this.simulationMrhForm.get('profession')?.valid &&
               this.simulationMrhForm.get('qualiteProposant')?.valid &&
               this.simulationMrhForm.get('adresseRisque')?.valid &&
               this.simulationMrhForm.get('nombrePieces')?.valid &&
               this.simulationMrhForm.get('valeurContenu')?.valid &&
               this.simulationMrhForm.get('valeurBatiment')?.valid &&
               this.isLoyerValid();
      
      case 2: // Choix des garanties
        return this.simulationMrhForm.get('garanties')?.valid &&
               this.simulationMrhForm.get('garanties')?.value.length > 0;
      
      default:
        return true;
    }
  }

  // Validation conditionnelle du loyer
  isLoyerValid(): boolean {
    const qualiteProposant = this.simulationMrhForm.get('qualiteProposant')?.value;
    const loyer = this.simulationMrhForm.get('loyer')?.value;
    
    if (qualiteProposant === 'Locataire') {
      return loyer && loyer.length > 0;
    }
    return true;
  }

  // Gestion du changement de qualité proposant
  onQualiteProposantChange() {
    const qualiteProposant = this.simulationMrhForm.get('qualiteProposant')?.value;
    const loyerControl = this.simulationMrhForm.get('loyer');
    
    if (qualiteProposant === 'Locataire') {
      loyerControl?.setValidators([Validators.required]);
    } else {
      loyerControl?.clearValidators();
      loyerControl?.setValue('');
    }
    loyerControl?.updateValueAndValidity();
  }

  // Gestion des garanties (checkboxes)
  onGarantieChange(garantie: string, event: any) {
    const garanties = this.simulationMrhForm.get('garanties')?.value || [];
    
    if (event.target.checked) {
      // Ajouter la garantie
      if (!garanties.includes(garantie)) {
        garanties.push(garantie);
      }
    } else {
      // Retirer la garantie
      const index = garanties.indexOf(garantie);
      if (index > -1) {
        garanties.splice(index, 1);
      }
    }
    
    this.simulationMrhForm.get('garanties')?.setValue(garanties);
  }

  // Vérifier si une garantie est sélectionnée
  isGarantieSelected(garantie: string): boolean {
    const garanties = this.simulationMrhForm.get('garanties')?.value || [];
    return garanties.includes(garantie);
  }

  markFormGroupTouched() {
    Object.keys(this.simulationMrhForm.controls).forEach(key => {
      const control = this.simulationMrhForm.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
  }

  // Gestion du téléphone
  hasError(event: any, field: string, form: string) {
    this.hasPhoneError = !event;
  }

  getNumber(number: string, field: string, form: string) {
    this.simulationMrhForm.get(field)?.setValue(number);
  }

  telInputObject(obj: any) {
    // Gestion de l'objet téléphone
  }

  onCountryChange(country: any) {
    // Gestion du changement de pays pour le téléphone
  }

  // Gestion des fichiers
  selectOnFile(evt: any, type?: string, name?: string) {
    this.nomFile = name || 'Fichier sélectionné';
    this.loader = true;
    
    const accept = ['.doc', '.DOC', '.docx', '.DOCX', '.docm', '.DOCM', '.pdf', '.PDF', 
                   '.xls', '.XLS', '.xlsx', '.XLSX', '.png', '.PNG', '.jpg', '.JPG', '.jpeg', '.JPEG'];
    
    for (const file of evt.target.files) {  
      const index = file.name.lastIndexOf(".");
      const strsubstring = file.name.substring(index, file.name.length);
      let ext = strsubstring;
      
      if (accept.indexOf(strsubstring) === -1) {
        this.loader = false;
        this.toastr.error(`Ce fichier ${file.name} n'est pas au format autorisé`, 'Erreur');
        evt.target.value = '';
        return;
      } else {
        this.loader = true;
        const reader = new FileReader();
        
        reader.onload = (e: any) => {
          const docBase64Path = e.target.result;
          let image = '';
          
          if (ext === '.doc' || ext === '.DOC' || ext === '.docx' || ext === '.DOCX' || ext === '.docm' || ext === '.DOCM') {
            image = 'assets/images/doc.png';
            this.noImage = 'assets/images/doc.png';
          }
          else if (ext === '.pdf' || ext === '.PDF') {
            image = 'assets/images/pdf.png';
            this.noImage = 'assets/images/pdf.png';
          }
          else if (ext === '.xlsx' || ext === '.XLSX' || ext === '.xls' || ext === '.XLS') {
            image = 'assets/images/excel.png';
            this.noImage = 'assets/images/excel.png';
          }
          else {
            image = docBase64Path;
            this.noImage = docBase64Path;
          }
          this.saveFile1(file);
        };
        reader.readAsDataURL(file);
      }
    }
  }

  saveFile1(file: File) {
    this.loader = true;
    let dataFile = new FormData();
    dataFile.append('files', file);
    
    this.rechercheService.saveFile(dataFile).subscribe(
      resp => {
        if (resp) {
          this.loader = false;
          this.toastr.success("Fichier chargé avec succès", 'Succès');
          this.pieceJointe.get('file')?.setValue(resp['urlprod']);
        }
      }, 
      error => {
        this.loader = false;
        this.noImage = "assets/images/upload.png";
        this.nomFile = "";
        const errorMessage = error?.error?.errors?.[0]?.message || 
                            error?.error?.message || 
                            "Erreur lors du chargement du fichier";
        
        this.toastr.error(errorMessage, 'Erreur');
        this.pieceJointe.get('file')?.setValue('');
      }
    );
  }

  downloadModel() {
    if (this.typeProduitList?.questionnaireUrl) {
      window.open(this.typeProduitList.questionnaireUrl, '_blank');
    } else {
      window.open('/assets/fileDownload/questionnaire_mrh.pdf', '_blank');
    }
    this.downloadFile = false;
  }

  // Sauvegarde
  saveData() {
    this.sendingRequest = true;
    this.loader = true;
    
    const finalData = {
      ...this.simulationMrhForm.value,
      pieceJointe: this.pieceJointe.value,
      numeroSous: this.numeroSous,
      refPro: this.refPro
    };

    const submissionData = {
      designationClient: finalData.nom,
      telephone: finalData.telephone,
      email: finalData.email,
      typeRisque: "MRH",
      content: JSON.stringify(finalData)
    };
    
    this.rechercheService.saveSouscriptionOffline(submissionData)
      .subscribe(response => {
        if (response['responseCode'] == 200) {
          this.sendingRequest = false;
          this.loader = false;
          this.toastr.success("Demande de souscription enregistrée avec succès");
          this.currentStep = 4; // Étape succès
        } else {
          this.sendingRequest = false;
          this.loader = false;
          this.toastr.error(response['cause'].erreurs[0].message);
        }
      }, errors => {
        this.sendingRequest = false;
        this.loader = false;
        const errorMessage = errors['error']['cause'].erreurs ? 
          errors['error']['cause'].erreurs[0].message : 
          errors['error']['cause']['message'];
        this.toastr.error(errorMessage);
      });
  }

  resetForm() {
    this.currentStep = 0;
    this.simulationMrhForm.reset();
    this.pieceJointe.reset();
    this.nomFile = "";
    this.noImage = "assets/images/upload.png";
    window.scrollTo(0, 0);
  }

  getProgressPercentage(): number {
    const progressSteps = {
      0: 0,   // Page d'accueil
      1: 50,  // Informations générales
      2: 75,  // Choix des garanties
      3: 100, // Récapitulatif
      4: 100  // Succès
    };
    
    return progressSteps[this.currentStep] || 0;
  }

  getProgressText(): string {
    const progressTexts = {
      0: 'Bienvenue...',
      1: 'Informations générales...',
      2: 'Choix des garanties...',
      3: 'Finalisation...',
      4: 'Terminé!'
    };
    
    return progressTexts[this.currentStep] || 'Chargement en cours...';
  }

  // Méthode utilitaire pour formater les montants
  formatMontant(value: string): string {
    if (!value) return '';
    return new Intl.NumberFormat('fr-FR').format(parseInt(value.replace(/\s/g, '')));
  }

  // Méthode pour gérer la saisie des montants
  onMontantInput(event: any, field: string) {
    let value = event.target.value.replace(/\s/g, '');
    if (value && !isNaN(value)) {
      const formattedValue = this.formatMontant(value);
      this.simulationMrhForm.get(field)?.setValue(formattedValue);
    }
  }

  // ===== CONFIGURATION DE L'AUTOSAVE =====
  private setupAutoSave() {
    this.autoSaveSubscription = this.autoSaveSubject$.pipe(
      debounceTime(1000),
      distinctUntilChanged((prev, curr) => {
        return prev.email === curr.email && prev.telephone === curr.telephone;
      }),
      switchMap(data => {
        const currentDataString = JSON.stringify({
          email: data.email,
          telephone: data.telephone
        });
        
        if (currentDataString === this.lastSavedData) {
          return of(null);
        }
        
        this.lastSavedData = currentDataString;
        
        return this.rechercheService.autoSave(data).pipe(
          catchError(error => {
            return of(null);
          })
        );
      })
    ).subscribe(response => {
    });
  }

  // ===== MÉTHODE AUTOSAVE AMÉLIORÉE =====
  autoSave() {
    const formValue = this.simulationMrhForm?.value;
    if (!formValue) return;

    const hasValidEmail = formValue.email && this.emailPattern.test(formValue.email);
    
    const hasValidPhone = formValue.telephone && formValue.telephone.trim().length >= 8;

    if (!hasValidEmail && !hasValidPhone) {
      return;
    }

    if (!this.currentFiliale?.id) {
      return;
    }

    const data = {
            "telephone": formValue.telephone?.trim(),
            "email": formValue.email?.trim().toLowerCase(),
            "adresse": formValue.adresse,
            "type": "ASSURANCE MULTIRISQUE HABITAT",
            "displayName": formValue.nom,
            "filiale": this.currentFiliale?.id,
    }; 

    this.autoSaveSubject$.next(data);
  }
  // ========================================


    getDevisAutre() {
        this.currentStep = 0;
        setTimeout(() => {
            window.scrollTo({
                top: 600,
                behavior: 'smooth'
            });
        }, 100);
  }

}